import { css } from "@emotion/react";
import React, { memo, useEffect, useState } from "react";
import { useAccount, useDisconnect, useNetwork } from "wagmi";
import * as _wagmi_core from "@wagmi/core";
import { useWindowSize } from "../../hooks/useWindowSize";
import {
  Footer,
  Header,
  ConnectWalletPopup,
  ChainPopup,
  Top,
  About,
  Information,
  Artist,
  TipsSection,
  Yokai,
} from "../organisms";
import StatusPopup from "../organisms/StatusPopup";

export const pageCSS = {
  titleStyle: css`
    text-transform: uppercase;
    color: #d65b56;
    margin-bottom: 24px;
    font-family: "Bebas Neue", cursive;
    font-size: 32px;
    font-weight: 300;
  `,
  nftSection: css`
    max-width: 860px;
    margin: 48px auto 0;
    text-align: center;
  `,
  buttonCss: [
    css`
      font-family: "Roboto Condensed", sans-serif;
      font-weight: bold;
      min-width: 134px;
      color: #fff;
      padding: 10px 24px;
      text-transform: uppercase;
      border: 0;
      border-radius: 3px;
      cursor: pointer;
      transition: opacity 0.3s;
      background-color: #e63c3c;
      white-space: nowrap;

      &:hover {
        opacity: 0.5;
      }
      &:disabled {
        background-color: #9d9d9d;
        &:hover {
          opacity: 1;
          cursor: auto;
        }
      }
    `,
    css`
      position: relative;
      width: 200px;
      border: 1px solid #fff;
      min-height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin: 0 auto;
    `,
  ],
};

interface TemplateProps {
  totalSupply?: any;
  maxSupply?: any;
  isPublicMintActive?: any;
  isWhitelistMintActive?: unknown;
  whitelistClaimed?: unknown;
  publicClaimed?: unknown;
  publicMint?: any;
  publicMintData?: _wagmi_core.SendTransactionResult | undefined;
  publicMintError: Error | null;
  allowlistMint?: any;
  allowlistMintData?: _wagmi_core.SendTransactionResult | undefined;
  allowlistMintError: Error | null;
  isClaimable: boolean;
}

const PageTemplate: React.FC<TemplateProps> = ({
  maxSupply,
  totalSupply,
  isPublicMintActive,
  isWhitelistMintActive,
  whitelistClaimed,
  publicClaimed,
  publicMint,
  publicMintData,
  publicMintError,
  allowlistMint,
  allowlistMintData,
  allowlistMintError,
  isClaimable,
}) => {
  const [_, height] = useWindowSize();

  const [isConnectPopupOpen, setIsConnectPopupOpen] = useState(false);
  const [isMintButtonDisabled, setIsMintButtonDisabled] = useState(false);
  const [isPublicMintButtonDisabled, setIsPublicMintButtonDisabled] =
    useState(false);

  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const { chain } = useNetwork();

  useEffect(() => {
    if (address === undefined) {
      return;
    }
    if (!isPublicMintActive && !isClaimable) {
      setIsMintButtonDisabled(true);
      return;
    }
    if (isWhitelistMintActive) {
      if (whitelistClaimed) {
        setIsMintButtonDisabled(true);
        return;
      } else {
        setIsMintButtonDisabled(false);
        return;
      }
    }
    if (isPublicMintActive) {
      if (publicClaimed) {
        setIsPublicMintButtonDisabled(true);
        return;
      } else {
        setIsPublicMintButtonDisabled(false);
        return;
      }
    }

    if (totalSupply === maxSupply) {
      //totalSupplyをmaxSupplyが同等だったら-> Mint非表示OpenSeaLink表示
      setIsMintButtonDisabled(true);
      setIsPublicMintButtonDisabled(true);
      return;
    }
  }, [
    address,
    maxSupply,
    totalSupply,
    isPublicMintActive,
    isWhitelistMintActive,
    publicClaimed,
    whitelistClaimed,
    isClaimable,
  ]);
  return (
    <div>
      <Header />
      <Top />
      <div>
        <div
          css={css`
            width: 100%;
          `}
        >
          <div
            css={css`
              position: relative;
              width: 100%;
              height: ${height - 62}px;
            `}
          >
            <img
              css={css`
                position: absolute;
                width: 40%;
                top: 45%;
                left: 50%;
                transform: translate(-50%, -50%);
              `}
              src="/img/hero_logo.png"
              alt="3600YAKO"
            />
          </div>
          <div
            css={css`
              background-image: url(/img/bg.jpg);
              background-color: #fff;
            `}
          >
            <div
              css={css`
                transform: translateY(-15%);
              `}
            >
              <About />
              <p
                css={css`
                  max-width: 860px;
                  text-align: center;
                  margin: 8px auto 0;
                  font-size: 12px;
                `}
              >
                <span>
                  This is just a preview and the NFT will be randomly drawn
                  after the reveal.
                </span>
              </p>
              <div id="nft" css={[pageCSS.nftSection]}>
                <div
                  css={css`
                    color: #e63c3c;
                  `}
                >{`${totalSupply ?? "---"} / ${
                  maxSupply ?? "---"
                } minted`}</div>
                    <button
                        css={pageCSS.buttonCss}
                        onClick={() => {
                          window.open(
                              `${process.env.REACT_APP_OPENSEA_COLLECTION_PAGE_LINK}`,
                              "_blank",
                              "noreferrer"
                          );
                        }}
                    >
                      <span>Opensea</span>
                    </button>
                {/*{isConnected &&*/}
                {/*  !!!isWhitelistMintActive &&*/}
                {/*  !!!isPublicMintActive && (*/}
                {/*    <button css={pageCSS.buttonCss} disabled={true}>*/}
                {/*      <>*/}
                {/*        <span>Unavailable</span>*/}
                {/*      </>*/}
                {/*    </button>*/}
                {/*  )}*/}
                {/*{isConnected &&*/}
                {/*  !!isWhitelistMintActive &&*/}
                {/*  !!!isPublicMintActive && (*/}
                {/*    <button*/}
                {/*      css={pageCSS.buttonCss}*/}
                {/*      onClick={() => {*/}
                {/*        if (address === undefined) {*/}
                {/*          return;*/}
                {/*        }*/}
                {/*        if (!whitelistClaimed) {*/}
                {/*          // allowlist Mint*/}
                {/*          allowlistMint?.();*/}
                {/*        }*/}
                {/*      }}*/}
                {/*      disabled={isMintButtonDisabled}*/}
                {/*    >*/}
                {/*      <>*/}
                {/*        <span>Allowlist Mint</span>*/}
                {/*        {whitelistClaimed && (*/}
                {/*          <span*/}
                {/*            css={css`*/}
                {/*              font-size: 10px;*/}
                {/*            `}*/}
                {/*          >*/}
                {/*            Already claimed*/}
                {/*          </span>*/}
                {/*        )}*/}
                {/*      </>*/}
                {/*    </button>*/}
                {/*  )}*/}
                {/*{isConnected &&*/}
                {/*  !!isPublicMintActive &&*/}
                {/*  Number(totalSupply) < Number(maxSupply) && (*/}
                {/*    <button*/}
                {/*      css={pageCSS.buttonCss}*/}
                {/*      onClick={() => {*/}
                {/*        if (address === undefined) {*/}
                {/*          return;*/}
                {/*        }*/}
                {/*        if (!publicClaimed) {*/}
                {/*          // Public Mint*/}
                {/*          publicMint?.();*/}
                {/*        }*/}
                {/*      }}*/}
                {/*      disabled={isPublicMintButtonDisabled || !!publicClaimed}*/}
                {/*    >*/}
                {/*      <>*/}
                {/*        <span>Mint</span>*/}
                {/*        {publicClaimed && (*/}
                {/*          <span*/}
                {/*            css={css`*/}
                {/*              font-size: 10px;*/}
                {/*            `}*/}
                {/*          >*/}
                {/*            Already claimed*/}
                {/*          </span>*/}
                {/*        )}*/}
                {/*      </>*/}
                {/*    </button>*/}
                {/*  )}*/}
                {/*{!isConnected && (*/}
                {/*  <button*/}
                {/*    css={pageCSS.buttonCss}*/}
                {/*    onClick={() => {*/}
                {/*      if (!isConnected) {*/}
                {/*        setIsConnectPopupOpen(true);*/}
                {/*      }*/}
                {/*    }}*/}
                {/*  >*/}
                {/*    <>*/}
                {/*      <span>Wallet Connect</span>*/}
                {/*    </>*/}
                {/*  </button>*/}
                {/*)}*/}
                {/*{isConnected && (*/}
                {/*  <div*/}
                {/*    css={css`*/}
                {/*      padding-top: 16px;*/}
                {/*    `}*/}
                {/*  >*/}
                {/*    <div*/}
                {/*      css={css`*/}
                {/*        font-size: 14px;*/}
                {/*      `}*/}
                {/*    >*/}
                {/*      {address !== undefined &&*/}
                {/*        `${address.slice(0, 4)}...${address.slice(-4)}`}*/}
                {/*    </div>*/}
                {/*    <button*/}
                {/*      css={css`*/}
                {/*        border: none;*/}
                {/*        background-color: transparent;*/}
                {/*        text-decoration: underline;*/}
                {/*        font-size: 14px;*/}
                {/*        cursor: pointer;*/}
                {/*      `}*/}
                {/*      onClick={() => disconnect()}*/}
                {/*    >*/}
                {/*      Disconnect*/}
                {/*    </button>*/}
                {/*  </div>*/}
                {/*)}*/}
              </div>
            </div>
          </div>
          <Information />
          <Artist />
          <TipsSection />
          <Yokai />
        </div>
      </div>
      <Footer />
      <ConnectWalletPopup
        open={isConnectPopupOpen}
        close={() => setIsConnectPopupOpen(false)}
      />
      <ChainPopup />
      <StatusPopup
        allowlistMintData={allowlistMintData}
        publicMintData={publicMintData}
        allowlistMintError={allowlistMintError}
        publicMintError={publicMintError}
        whitelistClaimed={whitelistClaimed}
        publicClaimed={publicClaimed}
        isPublicMintOpen={isPublicMintActive}
      />
    </div>
  );
};

export default memo(PageTemplate);
